<template>
  <div
    :class="
      twMerge(
        'relative rounded-2xl p-4',
        variant === 'teal' ? 'border border-teal-600/10' : neutralBorderClass,
        shadowClass,
        $attrs.class as string
      )
    "
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

const { variant = 'neutral', compact = false } = defineProps<{
  variant?: 'neutral' | 'teal'
  compact?: boolean
}>()

const neutralBorderClass = computed(() =>
  compact ? 'border border-gray-50' : 'border border-white'
)

const shadowClass = computed(() => {
  if (variant === 'teal') return 'elevated-card--teal'
  return compact ? 'elevated-card--neutral-compact' : 'elevated-card--neutral'
})
</script>

<style scoped lang="postcss">
.elevated-card--neutral {
  box-shadow: 0px 2px 12px 0px #0000000f;
}

.elevated-card--neutral-compact {
  box-shadow: 0px 2px 6px 0px #0000000f;
}

.elevated-card--teal {
  box-shadow: 0px 2px 12px 0px #047a881a;
}
</style>
